import { StackScreenProps } from "@react-navigation/stack";
import { Page, TextField, Button } from "@towersystems/roam-common-native";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SettingsRootParamList } from "../../../../types";
import {
  useGlobalSettingsProvider,
  useMutationUpdateGlobalSettings,
} from "../../../../utilities/global-settings/hooks";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { DynamicMobileText } from "../../../../components/DynamicMobileText";

export interface EditLaybyDepositScreenProps
  extends StackScreenProps<SettingsRootParamList, "EditLaybyDepositScreen"> {}

export const EditLaybyDepositScreen = ({
  navigation,
}: EditLaybyDepositScreenProps) => {
  const shouldFocus = useHasTransitionEnded(navigation);
  const globalSettings = useGlobalSettingsProvider();
  const { updateGlobalSettings } = useMutationUpdateGlobalSettings();
  const { defaultLaybyDepositPercentage } = globalSettings;
  const [value, setValue] = useState(defaultLaybyDepositPercentage.toString());

  const isDirty = useMemo(() => {
    return value !== defaultLaybyDepositPercentage.toString();
  }, [value, defaultLaybyDepositPercentage]);

  const isValid = useMemo(() => {
    const pattern = /^[1-9]\d?$|^0$/;
    return pattern.test(value);
  }, [value]);

  const handleOnSave = useCallback(async () => {
    return updateGlobalSettings({
      defaultLaybyDepositPercentage: parseInt(value),
    })
      .then((e) => navigation.goBack())
      .catch((err) => console.log(err));
  }, [value]);

  useEffect(() => {
    const disabled = !isDirty || !isValid;
    navigation.setOptions({
      headerTitleAlign: "center",
      headerTitle: () => <DynamicMobileText label="Edit Layby Deposit" />,
      headerStatusBarHeight: 10,
      headerRight: () => {
        return (
          <Button
            label="Save"
            isAction
            disabled={disabled}
            onPress={handleOnSave}
            size="compact"
          ></Button>
        );
      },
    });
  }, [isValid, handleOnSave, isDirty]);

  return (
    <Page scrollable={false} cover>
      <TextField
        placeholder="Layby deposit percent"
        value={value}
        onChangeText={(v) => setValue(v)}
        autoFocus={shouldFocus}
        formatterType="percentage"
        validationMessage={
          isValid ? undefined : "Please enter a valid percentage bewteen 0-99"
        }
      />
    </Page>
  );
};
